import React, { useState, useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function RecommendationPage() {
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [search, setSearch] = useState("");
  const [vendorsData, setVendorData] = useState([]);
  const [vendors, setVendors] = useState([]);

  const navigate = useNavigate();

  const coordinatorId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/v1/CoordinatorManagement/show-CoordinatorDetail/${coordinatorId}`
        );

        const data = JSON.parse(
          response.data?.data?.CoordinatorDetail?.[0]?.recommendation || []
        );

        setVendors(data); // ✅ Set extracted data in state
      } catch (error) {
        console.error("Error fetching vendors:", error);
      } finally {
      }
    };

    fetchVendors();
  }, []);

  console.log(vendors);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/v1/VendorManagement/show-AllVendorService`
        );
        const fetchedData = response.data.data.allVendorService;
        console.log("Fetched Data:", fetchedData); // Log the fetched data
        setVendorData(fetchedData);
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const handleToggle = (vendor) => {
    const filteredVendor = {
      ...vendor, 
      Coordinators_ID: coordinatorId, 
    };
  
    setSelectedVendors((prev) => {
      const isSelected = prev.some((v) => v.id === vendor.id);
  
      if (isSelected) {
        // ✅ Remove from selectedVendors if it's already selected
        return prev.filter((v) => v.id !== vendor.id);
      } else {
        // ✅ Add vendor to selectedVendors, even if it's in vendors
        return [...prev, filteredVendor];
      }
    });
  };
  
  const removeVendor = (index) => {
    setSelectedVendors((prev) => prev.filter((_, i) => i !== index));
  
    axios
      .request({
        method: "DELETE",
        url: `${BASE_URL}/api/v1/CoordinatorManagement/DeleteRecommendation-Details`,
        data: {
          Coordinators_ID: coordinatorId, // Replace with actual coordinator ID if dynamic
          index: index, // Sending index instead of ID
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          alert("Vendor removed successfully");
          window.location.reload()
        }
      })
      .catch((error) => {
        console.error("Error removing vendor:", error);
        alert("Failed to remove vendor. Please try again.");
      });
  };
  

  console.log(selectedVendors);

  const HandleBack = () => {
    navigate("/co-ordinator-dashboard");
  };

  const filteredVendors = vendorsData
    .filter((vendor) =>
      vendor.Vendor.firstName.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) =>
      a.Category.CategorieName.localeCompare(b.Category.CategorieName)
    );

  const handleSubmit = async () => {
    if (selectedVendors.length === 0) {
      alert("Please select at least one vendor before submitting.");
      return;
    }

    try {
      const token = localStorage.getItem("token"); // Get the token

      console.log(selectedVendors);
      const response = await axios.post(
        `${BASE_URL}/api/v1/CoordinatorManagement/Recommendation-Details`,
        selectedVendors, // Send as it is, without mapping
        {
          headers: {
            // ✅ Fix: Correct key (lowercase 'headers')
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Submission Success:", response.data);
      alert("Vendors submitted successfully!");
      window.location.reload()

      setSelectedVendors([]); // Clear selection after submission
    } catch (error) {
      console.error(
        "Error submitting vendors:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to submit vendors. Please try again.");
    }
  };

  return (
    <div
      className="p-6 max-w-4xl  bg-gradient-to-r from-blue-100 to-blue-200 "
      style={{ margin: "40px" }}
    >
      <Button
        variant="contained"
        color="secondary"
        onClick={HandleBack}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>
      <h2 className="text-4xl font-bold text-center mb-6 text-blue-900 mt-5">
        Preferred Vendors List
      </h2>

      <div className="relative mb-6 d-flex justify-content-center mb-3">
        <SearchIcon
          className="absolute left-3 text-blue-600 "
          style={{ height: "2em", width: "2em" }}
        />
        <input
          type="text"
          placeholder="Search vendors..."
          style={{ width: "40%", borderRadius: "6px" }}
          className=" p-3 pl-10 border-2 border-blue-400 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-600"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <TableContainer component={Paper} className="mb-3 overflow-scroll">
        <Table>
          <TableHead>
            <TableRow className="bg-blue-500">
              <TableCell className="text-black font-bold">#</TableCell>
              <TableCell className="text-black font-bold">
                Vendor Name
              </TableCell>
              <TableCell className="text-black font-bold">Category</TableCell>
              <TableCell className="text-black font-bold">
                Service Locations
              </TableCell>
              <TableCell className="text-black font-bold">City</TableCell>
              <TableCell className="text-black font-bold">Mobile</TableCell>
              <TableCell className="text-black font-bold">Email</TableCell>
              <TableCell className="text-black font-bold">Budget</TableCell>
              <TableCell className="text-black font-bold text-center">
                Select
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredVendors &&
              filteredVendors
                .filter((data) => data.status === "approved")
                .map((vendor, index) => (
                  <TableRow
                    key={vendor.id}
                    className="hover:bg-blue-100 transition-all"
                  >
                    <TableCell className="font-medium text-blue-900">
                      {index + 1}
                    </TableCell>
                    <TableCell className="font-medium text-blue-900">
                      {vendor.Vendor.firstName} {vendor.Vendor.lastName}{" "}
                    </TableCell>
                    <TableCell className="text-gray-700">
                      {vendor.Category.CategorieName}
                    </TableCell>
                    <TableCell className="text-gray-700">
                      {JSON.parse(vendor.ServiceLocations).join(", ")}
                    </TableCell>
                    <TableCell className="text-gray-700">
                      {vendor.City}
                    </TableCell>
                    <TableCell className="text-gray-700">
                      {vendor.Vendor.mobile_number}
                    </TableCell>
                    <TableCell className="text-gray-700">
                      {vendor.Vendor.email}
                    </TableCell>
                    <TableCell className="text-gray-700">
                      {vendor.TotalBudget}
                    </TableCell>
                    <TableCell className="text-center">
                      <Checkbox
                        checked={
                          selectedVendors.some((v) => v.id === vendor.id) ||
                          vendors.some((v) => v.id === vendor.id)
                        }
                        onChange={() => handleToggle(vendor)}
                        color="primary"
                      />
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>

      {(selectedVendors.length > 0 || vendors.length > 0) && (
        <div className="mt-6 p-5 bg-green-200 border-2 border-green-400">
          <h3 className="text-xl font-semibold text-green-900 flex items-center">
            <CheckCircleIcon className="mr-2 text-green-700" /> Selected
            Vendors:
          </h3>
          <ul className="mt-2 text-green-800 font-medium text-lg">
            {[
              ...selectedVendors,
              ...vendors.filter(
                (vendor) => !selectedVendors.some((v) => v.id === vendor.id)
              ), // Prevent duplicates
            ].map((vendor,index) => (
              <li
                key={vendor.id}
                className="p-1 flex justify-between items-center"
              >
                <span>
                  ✔ {vendor.Vendor.firstName} {vendor.Vendor.lastName} -{" "}
                  {vendor.ServiceName}
                </span>
                <Link
                  href="#"
                  className="ml-3 text-red-600 hover:text-red-800 cursor-pointer font-bold bg-transparent border-none p-0"
                  style={{ textDecoration: "none" }}
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default link behavior
                    removeVendor(index);
                  }}
                >
                  ❌
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      <Button
        className="ml-2"
        variant="contained"
        color="success"
        style={{ marginLeft: "20px" }}
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </div>
  );
}
